import styled, { css } from 'styled-components';
import { TypographyStyles, colours, media, spacing } from '../../../stylings';

export const Container = styled.div<{ $isStar2?: boolean }>`
  ${({ $isStar2 }) =>
    $isStar2
      ? css`
          flex-wrap: wrap;
        `
      : null}
  align-items: center;
  display: flex;
  gap: ${spacing.XXXS};

  @media ${media.greaterThan('lg')} {
    gap: ${spacing.XS};
  }
`;

export const Header = styled.h1`
  ${TypographyStyles.Headings.H3}
  margin: 0;
  text-transform: uppercase;
`;

export const Subheading = styled.div`
  align-items: center;
  display: flex;
  gap: ${spacing.XXXXS};
`;

export const ItemCount = styled.span`
  ${TypographyStyles.Body.Small.Regular}
  color: ${colours.GREY};
  white-space: nowrap;
`;

export const Divider = styled.span`
  ${TypographyStyles.Body.Small.Regular}
  color: ${colours.GREY};
`;

export const Total = styled.span`
  ${TypographyStyles.Body.Small.SemiBold}
`;
